import React from 'react';

import { Grid, makeStyles, Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import {
  AvgMaxCountAccess,
  PeriodCountAccess,
  DateFilterFields,
} from 'modules/environments/interfaces';
import { filterAvgMaxOptions, filterPeriodOptions } from 'utils/graphs';
import FilterSelector from 'components/FilterSelector';
import { getEnvironmentPerformanceCPURequest } from 'modules/environments/actions';
import i18n from 'i18n';
import { useParams } from 'react-router';
import DateFilter from 'components/DateFilter';
import styles, { overrideFilter } from './styles';
import CPUGraph from './CPUGraph';

interface CPUGraphModalProps {
  avgMaxFilter: AvgMaxCountAccess;
  periodFilter: PeriodCountAccess;
  getEnvironmentPerformanceCPURequest: ({ id, query }) => void;
}

const CPUGraphModal = ({
  avgMaxFilter,
  periodFilter,
  getEnvironmentPerformanceCPURequest,
}: CPUGraphModalProps) => {
  const { id } = useParams<{
    id: string;
  }>();
  const classes = makeStyles(styles())();

  const [period, setPeriod] = React.useState<PeriodCountAccess | string>(
    periodFilter
  );
  const [avgMax, setAvgMax] = React.useState<AvgMaxCountAccess | string>(
    avgMaxFilter
  );
  const [dateFilter, setDateFilter] = React.useState<DateFilterFields>({
    'start-date': '',
    'end-date': '',
  });
  const [openDateFilter, setOpenDateFilter] = React.useState(false);

  React.useEffect(() => {
    const query =
      dateFilter?.['start-date'] && dateFilter?.['end-date']
        ? dateFilter
        : { period };

    getEnvironmentPerformanceCPURequest({ id, query });
  }, [getEnvironmentPerformanceCPURequest, id, period, dateFilter]);

  return (
    <Grid container className={classes.modalGraph}>
      <Grid container className={classes.legend}>
        <Grid item className={classes.filtersContainer}>
          <DateFilter
            onOpenFilter={setOpenDateFilter}
            onSubmit={setDateFilter}
          />
          {!openDateFilter && (
            <FilterSelector
              overrideClasses={overrideFilter}
              options={filterPeriodOptions(setPeriod)}
              currentValue={{
                label: i18n.t(
                  `ENVIRONMENT_DASHBOARD.LAST_${period.toUpperCase()}`
                ),
                onClick: () => null,
              }}
            />
          )}
        </Grid>
        <Grid className={classes.filterAvgMaxContainer}>
          <Divider
            variant="middle"
            orientation="vertical"
            className={classes.divider}
          />
          <FilterSelector
            overrideClasses={overrideFilter}
            options={filterAvgMaxOptions(setAvgMax)}
            currentValue={{
              label: i18n.t(`PERFORMANCE_PAGE.${avgMax.toUpperCase()}_KEY`),
              onClick: () => null,
            }}
          />
        </Grid>
      </Grid>
      <CPUGraph filter={avgMax} />
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { periodFilter, environmentAvgMaxFilterCPU },
}: ApplicationState) => ({
  periodFilter,
  avgMaxFilter: environmentAvgMaxFilterCPU,
});

export default connect(mapStateToProps, {
  getEnvironmentPerformanceCPURequest,
})(CPUGraphModal);
